import * as React from "react";
import { useCallback, useMemo, useState } from "react";
import usePluginEntities from "hooks/usePluginEntities";
import usePersistedSetting from "hooks/usePersistedSetting";
import PerspectivesContext from "./PerspectivesContext";
export const DEFAULT_PERSPECTIVE = "default";
const findPerspective = (perspectives, perspectiveId) => perspectives.find(({ id }) => id === perspectiveId);
const useActivePerspectiveState = (availablePerspectives) => {
  const [persistedPerspective, setPersistedPerspective] = usePersistedSetting("perspective");
  const [activePerspective, setActivePerspective] = useState(
    findPerspective(availablePerspectives, persistedPerspective) ? persistedPerspective : DEFAULT_PERSPECTIVE
  );
  const setActivePerspectiveWithPersistence = useCallback(
    (newPerspective) => {
      setActivePerspective(newPerspective);
      return setPersistedPerspective(newPerspective);
    },
    [setPersistedPerspective]
  );
  return {
    activePerspective: findPerspective(availablePerspectives, activePerspective),
    setActivePerspective: setActivePerspectiveWithPersistence
  };
};
const PerspectivesProvider = ({ children }) => {
  const allPerspectives = usePluginEntities("perspectives");
  const availablePerspectives = allPerspectives.filter(
    (perspective) => perspective.useCondition ? !!perspective.useCondition() : true
  );
  const { activePerspective, setActivePerspective } = useActivePerspectiveState(availablePerspectives);
  const contextValue = useMemo(
    () => ({
      activePerspective,
      availablePerspectives,
      setActivePerspective
    }),
    [activePerspective, availablePerspectives, setActivePerspective]
  );
  return /* @__PURE__ */ React.createElement(PerspectivesContext.Provider, { value: contextValue }, children);
};
export default PerspectivesProvider;
